module.exports = __webpack_public_path__ + "img/avatar_1.f7c7eba3.jpg";